/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
// import parse from "html-react-parser";

class AlramItem extends Component {
  state = {
    mouseOn: false,
  };
  componentDidMount = () => {};
  _goItem = () => {
    const { setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;
    setContentSerial(contentSerial);
    //history.push('/items/' + contentSerial)
  };
  _change = () => {
    const { _selected, index, contentSerial } = this.props.childProps;
    //console.log(index, contentSerial)
    _selected(index, contentSerial);
  };
  render() {
    const { contentSerial, title, img, genreName, sameCode, selected } =
      this.props.childProps;

    return (
      <Fragment>
        <ul>
          <li
            className="thumb"
            onClick={this._goItem}
            style={{ cursor: "pointer" }}
          >
            <img src={img} />
          </li>
          <li className="info">
            <p
              className="subject"
              onClick={this._goItem}
              style={{ cursor: "pointer" }}
            >
              {title}
            </p>
            <p className="time">
              <span>장르</span>
              {genreName}
              {/*<span>LIVE</span>*/}
              {/*2021.05.28 (금) 23:30  -  25화 달 아래에서, 엉터리 댄스를*/}
            </p>
            <p className="time">
              <span>방영일</span>
              {sameCode.substr(0, 4)}.{sameCode.substr(4, 2)}
              {/*<span>TV</span>*/}
              {/*2021.05.28 (금) 23:30  -  25화 달 아래에서, 엉터리 댄스를*/}
            </p>
          </li>
          <input
            type="checkbox"
            className="chkBox"
            name="chk"
            checked={selected > 0 ? true : false}
            onChange={this._change}
            id={"chk" + contentSerial}
          />
          <label htmlFor={"chk" + contentSerial} className="chk"></label>
        </ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(AlramItem)));
